import { render, staticRenderFns } from "./PortfolioComparisonView.vue?vue&type=template&id=9cae8d22&scoped=true"
import script from "./PortfolioComparisonView.vue?vue&type=script&lang=js"
export * from "./PortfolioComparisonView.vue?vue&type=script&lang=js"
import style0 from "./PortfolioComparisonView.vue?vue&type=style&index=0&id=9cae8d22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cae8d22",
  null
  
)

export default component.exports